import { Component, Emit, Model, Prop, Vue } from 'vue-property-decorator';

export interface MenuItem {
  title: string;
  icon: string;
}

@Component({})
export default class VMenuList extends Vue {
  @Prop({ type: Array })
  readonly items!: MenuItem[];

  @Model('input', {})
  value!: number | false;

  get activeItem(): number | false {
    return this.value;
  }

  set activeItem(val: number | false) {
    const result = val !== undefined ? val : false;
    this.updateValue(result);
  }

  @Emit('input')
  updateValue(val: number | false): number | false {
    return val;
  }
}
